/**
 * Shared severity metadata for the Logs Explorer.
 *
 * The eight PSR-3 levels are kept as they are, never collapsed into bands:
 * the facets sidebar filters on raw levels, so the chart has to speak the
 * same vocabulary. Order is least to most severe — which is also the stacking
 * order, since ApexCharts stacks the first series at the bottom.
 */
export const SEVERITY_LEVELS = [
    'debug',
    'info',
    'notice',
    'warning',
    'error',
    'critical',
    'alert',
    'emergency',
];

/**
 * A ramp that reads as severity at a glance: neutral grey, then cool, then
 * warm, then progressively darker reds. AdminLTE hues where they exist.
 */
export const SEVERITY_COLORS = {
    debug: '#999999',
    info: '#00c0ef',
    notice: '#3c8dbc',
    warning: '#f39c12',
    error: '#dd4b39',
    critical: '#b03d2e',
    alert: '#7d2b20',
    emergency: '#3d1410',
};

export function levelColor(level) {
    return SEVERITY_COLORS[level] ?? SEVERITY_COLORS.info;
}

export const TIME_RANGES = [
    { key: '15m', label: 'Last 15 min', minutes: 15, bucketMinutes: 1 },
    { key: '1h', label: 'Last 1 hour', minutes: 60, bucketMinutes: 2 },
    { key: '24h', label: 'Last 24 hours', minutes: 1440, bucketMinutes: 30 },
    { key: '7d', label: 'Last 7 days', minutes: 10080, bucketMinutes: 240 },
    { key: '30d', label: 'Last 30 days', minutes: 43200, bucketMinutes: 1440 },
];
